var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17,0 C17.8520894,0 18.5428082,0.690718791 18.5428082,1.54280822 L18.5425753,15.4564932 L32.4571918,15.4571918 C33.2644344,15.4571918 33.9268457,16.0771167 33.9943371,16.8668778 L34,17 C34,17.8520894 33.3092812,18.5428082 32.4571918,18.5428082 L18.5425753,18.5425753 L18.5428082,32.4571918 C18.5428082,33.2644344 17.9228833,33.9268457 17.1331222,33.9943371 L17,34 C16.1479106,34 15.4571918,33.3092812 15.4571918,32.4571918 L15.4564932,18.5425753 L1.54280822,18.5428082 C0.735565603,18.5428082 0.0731542512,17.9228833 0.00566286965,17.1331222 L0,17 C0,16.1479106 0.690718791,15.4571918 1.54280822,15.4571918 L15.4564932,15.4564932 L15.4571918,1.54280822 C15.4571918,0.735565603 16.0771167,0.0731542512 16.8668778,0.00566286965 L17,0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus_blue.96270aaa6cbb49bb02d8187f28613daf.svg";
export { ForwardRef as ReactComponent };